// Heritage Community College program catalog
// Sourced from hccbc.com/diploma-programs.php and hccbc.com/certificate-programs.php
// (Synced Feb 2026.)
//
// `length` is the human-readable label scraped from the website.
// `hours / weeks / months / years` are best-effort numeric extractions used
// to pre-fill the Domestic Application form's Program Length section.

export const HCC_PROGRAMS = [
  // -------- Diploma --------
  { type: 'Diploma', name: 'Accounting & Payroll', length: '8 Months', months: 8 },
  { type: 'Diploma', name: 'Digital Marketing Management', length: '12 Months', months: 12 },
  { type: 'Diploma', name: 'Human Resource Administration', length: '11 Months', months: 11 },
  { type: 'Diploma', name: 'International Business', length: '18 Months', months: 18 },
  { type: 'Diploma', name: 'Marketing Administrator', length: '9.5 Months', months: 9.5 },
  { type: 'Diploma', name: 'Office Administrator (Diploma)', length: '6.5 Months', months: 6.5 },
  { type: 'Diploma', name: 'Addiction Community Support Worker', length: '10.5 Months', months: 10.5 },
  { type: 'Diploma', name: 'Health Care Assistant', length: '5.7 Months', months: 5.7 },
  { type: 'Diploma', name: 'Medical Office Assistant', length: '9 Months', months: 9 },
  { type: 'Diploma', name: 'Social Services Support', length: '9 Months', months: 9 },
  { type: 'Diploma', name: 'Hospitality Management', length: '8.7 Months', months: 8.7 },
  { type: 'Diploma', name: 'Network Support Administrator', length: '10.75 Months', months: 10.75 },
  { type: 'Diploma', name: 'Network Support Technician', length: '6 Months', months: 6 },

  // -------- Certificate --------
  { type: 'Certificate', name: 'Child Growth & Development I', length: '45 Hours', hours: 45 },
  { type: 'Certificate', name: 'Child Growth & Development II', length: '45 Hours', hours: 45 },
  { type: 'Certificate', name: 'Child Guidance', length: '45 Hours', hours: 45 },
  { type: 'Certificate', name: 'Child Health, Safety & Nutrition', length: '45 Hours', hours: 45 },
  { type: 'Certificate', name: 'Interpersonal Communication', length: '45 Hours', hours: 45 },
  { type: 'Certificate', name: 'Accounting & Payroll Administration', length: '5 Months', months: 5 },
  { type: 'Certificate', name: 'Bank Teller', length: 'Every Month', months: 1 },
  { type: 'Certificate', name: 'Corporate Sales Management Strategies', length: 'Every Month', months: 1 },
  { type: 'Certificate', name: 'English Skills For College', length: '4 Months', months: 4 },
  { type: 'Certificate', name: 'Office Administrator (Certificate)', length: '6 Months', months: 6 },
  { type: 'Certificate', name: 'ECEA Courses', length: '135 Hours', hours: 135 },
];

export const HCC_CAMPUSES = [
  { name: 'Surrey', address: 'Unit 110, 8166 128th Street, Surrey, BC, V3W 1R1' },
  { name: 'Victoria', address: '759 Courtney St, Victoria, BC, V8W 1C3' },
];

export const HCC_DLI = 'O132232057367';
export const HCC_PUBLIC_EMAIL = 'info@hccbc.com';
export const HCC_WEBSITE = 'www.hccbc.com';

// Asset URLs (bundled in /src/assets/branding so jsPDF can load them same-origin)
import hccLogoAsset from '../assets/branding/hcc-logo.png';
import accredBcDesignated from '../assets/branding/accred-bc-designated.png';
import accredBcCareAid from '../assets/branding/accred-bc-care-aid.png';
import accredNacc from '../assets/branding/accred-nacc.png';
import accredEqa from '../assets/branding/accred-eqa.png';
import accredStudentAidBc from '../assets/branding/accred-studentaid-bc.png';

export const HCC_LOGO_URL = hccLogoAsset;

export const HCC_ACCREDITATION_LOGOS = [
  { label: 'BC Designated', url: accredBcDesignated },
  { label: 'BC Care Aid Registry', url: accredBcCareAid },
  { label: 'NACC', url: accredNacc },
  { label: 'EQA', url: accredEqa },
  { label: 'StudentAid BC', url: accredStudentAidBc },
];
